import EditRFQ from './EditRFQ';

export default EditRFQ;



// WEBPACK FOOTER //
// ./src/components/forms/EditRFQForm/index.jsx